"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auth = function Auth() {
  (0, _classCallCheck3.default)(this, Auth);
};

Auth.signin = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(api, _ref) {
    var username = _ref.username,
        password = _ref.password;

    var _ref3, token, user;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api.fetchJson("auth/login", {}, "post", {
              username: username,
              password: password
            });

          case 2:
            _ref3 = _context.sent;
            token = _ref3.token;
            user = _ref3.user;

            api.backend.setToken(token);
            return _context.abrupt("return", { user: user });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

Auth.signout = function (api) {
  api.backend.setToken(undefined);
};

exports.default = Auth;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/Auth.js
// module id = 319
// module chunks = 0